import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import ReportTable from "Reporting/Components/ReportTable";
import { useActiveTicketsQualified } from "./useActiveTicketsQualified";
import Loader from "shared/Loader";

/*
 * Table displaying different items in a report using Diamond integration
 */
export default function ReportTableListQualified({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);

  const { data, isLoading, isError, refetch } = useActiveTicketsQualified({
    year: filters.year,
    type: filters.type,
    owners: filters.owners,
  });
  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);
  useEffect(() => {
    if (data) {
      setReports(data);
      setReportsLength?.(data.length || 0);
      setReportData?.(data);
    }
  }, [data]);

  if (isError) {
    return <div>Something went wrong...</div>;
  }
  if (isLoading) {
    return <Loader />;
  }
  if (reports.length === 0) {
    return <div>No Reports Found</div>;
  }

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <React.Fragment key={index}>
          <ReportTable item={report} index={index} reports={reports} />
        </React.Fragment>
      ))}
    </div>
  );
}
